import { styled, Box } from '@mui/material';

export const StyledBox = styled(Box)(() => ({
  border: '1px solid #F0F0F0',
  backgroundColor: 'white',
  borderRadius: '10px',
  padding: '16px',
}));
